import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_191: DocMigration = {
  maxSchemaVersion: "0.0.191",
  description: "Adds setting to toggle ceiling open-to-above annotation on for existing homes",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "PORCH_SETTINGS" || setting.type === "REAR_PORCH_SETTINGS") {
        if (setting["removeHeaderAndColumns"]) {
          setting["removeHeader"] = true;
          setting["removeColumns"] = true;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_191;
